import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './Onboarding.module.scss';
import img1 from 'images/onboarding/1.png';
import img2 from 'images/onboarding/2.png';
import img3 from 'images/onboarding/3.png';
import img4 from 'images/onboarding/4.png';
import Button from 'components/shared/Button';
import { useTranslation } from 'react-i18next';

enum Steps {
  START,
  SLIDES,
}

const Onboarding = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const navigate = useNavigate(); // Хук для навигации
  const [steps, setSteps] = useState(Steps.START);
  const { t } = useTranslation() as any;

  const slides = [
    {
      img: img1,
      title: t('onboarding.slides.0.title'),
      description: t('onboarding.slides.0.description'),
    },
    {
      img: img2,
      title: 'Book Appointments Easily',
      description: 'Find the best professionals and book your appointment in seconds.',
    },
    {
      img: img3,
      title: 'Explore Top-rated Products',
      description: 'Browse top-rated products and shop with confidence.',
    },
    {
      img: img4,
      title: 'Enjoy the Experience',
      description: 'Experience the best services from trusted providers around you.',
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => setSteps(Steps.SLIDES), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleNext = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);

    setTimeout(() => {
      if (currentSlide === slides.length - 1) {
        navigate('/feed');
      } else {
        setCurrentSlide(prev => prev + 1);
      }
      setIsTransitioning(false);
    }, 600);
  };

  return (
    <>
      {steps === Steps.START && (
        <div className={s.onboarding}>
          <div className={s.onboarding_title}>
            {Array.from('BEAUTIFY').map((letter, index) => (
              <span key={index} className={s.letter} style={{ animationDelay: `${index * 0.2}s` }}>
                {letter}
              </span>
            ))}
          </div>
        </div>
      )}
      {steps === Steps.SLIDES && (
        <div
          className={`${s.onboarding_step} ${isTransitioning ? s.zoomOut : s.zoomIn}`}
          style={{
            backgroundImage: `url(${slides[currentSlide].img})`,
          }}
        >
          <div className={s.onboarding_step_inf}>
            <div className={s.onboarding_step_inf_title}>{slides[currentSlide].title}</div>
            <div className={s.onboarding_step_inf_description}>
              {slides[currentSlide].description}
            </div>
            <Button wide darkGreen className={s.onboarding_button} onClick={handleNext}>
              {currentSlide === slides.length - 1 ? 'Finish' : t('next')}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Onboarding;
